import { useEffect, useState, useCallback } from 'react';
import { useConsent } from './useConsent';

const KEY = 'ter_grand_est_favorites';

/**
 * Stations a user has bookmarked. Persisted to localStorage only when the
 * user has accepted cookies — otherwise reads return whatever is already in
 * memory (no new write), which is the CNIL-aligned behaviour for non-strictly
 * necessary preference storage.
 */
export const useFavorites = () => {
  const [favorites, setFavorites] = useState([]);
  const { canStorePreferences } = useConsent();

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) setFavorites(JSON.parse(raw));
    } catch { /* noop */ }
  }, []);

  const safeWrite = useCallback((next) => {
    if (!canStorePreferences) return;
    try { localStorage.setItem(KEY, JSON.stringify(next)); } catch { /* noop */ }
  }, [canStorePreferences]);

  const persist = useCallback((next) => {
    setFavorites(next);
    safeWrite(next);
  }, [safeWrite]);

  const toggleFavorite = useCallback((name) => {
    setFavorites((prev) => {
      const next = prev.includes(name) ? prev.filter(n => n !== name) : [...prev, name];
      safeWrite(next);
      return next;
    });
  }, [safeWrite]);

  const isFavorite = useCallback((name) => favorites.includes(name), [favorites]);

  return { favorites, toggleFavorite, isFavorite, setFavorites: persist, canStore: canStorePreferences };
};
